/**
 * Copyright (c) Omnissa, LLC. All rights reserved.
 * This product is protected by copyright and intellectual property laws in the
 * United States and other countries as well as by international treaties.
 * -- Omnissa Restricted
 *
 * @format
 */

export abstract class UserInfoService {
   public abstract getUserName(): string;
   public abstract getUserPrincipalName(): string;
   public abstract getDomainName(): string;
   public abstract setDomainName(domain: string);
}
